import React, { useContext } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { GlobalContext } from '../../state/global/GlobalContextProvider';
import DownloadIcon from "../../static/dc-transparent.gif";

export default function ApiLoader(props) {

  const globalCtx = useContext(GlobalContext);
  const { open } = props

  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open || globalCtx.globalState.loader}
      >
        <img style={{ width: '70px', position: 'relative', background: '#fffffff0', borderRadius: '52px' }} src={DownloadIcon} />
      </Backdrop>
    </div>
  );
}